import apiClient from "./axiosInstance"

export const TAgetSmlManagers = async (
  page: number,
  perPage: number,
  sortBy: string,
  sortOrder: boolean,
) => {
  const response = await apiClient.get(
    `/admin/manager/managers?page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAcreateSmlManagers = async (data: Record<string, unknown>) => {
  const response = await apiClient.post("/admin/manager/create-manager", data)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAupdateSmlManagers = async (_id: string, manager: Record<string, unknown>) => {
  const response = await apiClient.post(`/admin/manager/update-manager?_id=${_id}`, manager)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAdeleteSmlManagers = async (_id: string) => {
  const response = await apiClient.delete(`/admin/manager/delete-manager?_id=${_id}`)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAmanagerReport = async (id: string) => {
  const response = await apiClient.get(`/admin/manager/report?analysis=${id}`, {
    responseType: "blob",
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAmanagerPost = async (managerIds: string[]) => {
  const response = await apiClient.post("/admin/manager/manager-posts", managerIds)
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}
